import { useFeatureFlags } from './useFeatureFlags'

export default function useCommonVars() {
	const { FRONTEND_COMMON_VARS } = useFeatureFlags()
	return FRONTEND_COMMON_VARS
}
